<template>
    <div>
        <reset-form></reset-form>
    </div>
</template>
<script>
import resetForm from "@/components/forms/form-reset-password.vue"

export default {
    components: {
        resetForm
    }
}
</script>